import gsap from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { SplitText } from 'gsap/SplitText';
import { Parallax as ToolsParallax } from './tools/parallax';

gsap.registerPlugin(ScrollToPlugin, SplitText);
const Parallax = new ToolsParallax()

/**
 * Renderers
 */

const renderers = {
    home: () => {
        // if (window.innerWidth >= 768) {
        //     const tl = gsap.timeline({paused:true});
        //     const servicescols = document.querySelectorAll('#root-services:not(.service-solo) .item-root-service')
        //     const slogan = document.querySelector('#root-home-message > *')
        //     if (slogan) {
        //         tl.fromTo(slogan, {
        //             opacity: 0,
        //             y: -10
        //         }, {
        //             opacity: 1,
        //             y: 0,
        //             duration: 1.5,
        //             ease: "power2.out"
        //         }, 'start')
        //     }
        //     if (servicescols.length) {
        //         servicescols.forEach(function (item, i) {
        //             // col
        //             tl.fromTo(item, {
        //                 opacity: 0,
        //             }, {
        //                 opacity: 1,
        //                 duration: 1,
        //                 // delay: .015*i,
        //                 ease: "power2.out"
        //             }, 'start')
        //
        //             // subtitles
        //             // const splittextsubtitles = new SplitText(item.querySelector('.sub-title-service'), {type:"lines", linesClass: "split-line-child"});
        //             // new SplitText(item.querySelector('.sub-title-service'), {type:"lines", linesClass: "split-line-parent"});
        //             // tl.from(splittextsubtitles.lines, { duration: 1.5, y: 100, ease: "power4", stagger: 0.1, delay: .05*i }, 'start');
        //
        //             // titles
        //             const splittext = new SplitText(item.querySelector('.title-service'), {type:"lines", linesClass: "split-line-child"});
        //             new SplitText(item.querySelector('.title-service'), {type:"lines", linesClass: "split-line-parent"});
        //             tl.from(splittext.lines, { duration: .85, y: 100, ease: "power4.easeOut", stagger: 0.1, delay: .05*i }, 'start+=.15');
        //
        //             const btn = item.querySelector('.btn-service')
        //             if (btn) {
        //                 const btnrect = btn.getBoundingClientRect()
        //                 const wrapper = btn.parentNode
        //                 wrapper.style.height = btnrect.height+'px'
        //                 wrapper.style.overflow = 'hidden'
        //                 tl.from(btn, {
        //                     y: -100,
        //                     opacity: 0,
        //                     duration: .85,
        //                     // delay: .3*i,
        //                     ease: "power4.easeOut"
        //                 }, 'start+=.15')
        //             }
        //         });
        //     }
        //     tl.addLabel("start", 0);
        //     tl.eventCallback("onComplete", function() {
        //         /** Init particles */
        //         self.components.particles.init()
        //         Parallax.updateItems()
        //     });
        //     if (document.body.classList.contains('nav-status-fullloading')) {
        //         document.onreadystatechange = function () {
        //             if (document.readyState === "complete") {
        //                 tl.play()
        //             }
        //         }
        //     } else {
        //         tl.play()
        //     }
        // }
    },
    page: () => {},
    Level1: () => {
        const servicesolo = document.querySelector('#root-services.service-solo .item-root-service')
        const btn = servicesolo.querySelector('.btn')
        if (!servicesolo.classList.contains('animation-completed')) {
            const tl = gsap.timeline({delay:1,paused:true})
            if (servicesolo) {
                // col
                tl.fromTo(servicesolo, {
                    opacity: 0,
                }, {
                    opacity: 1,
                    duration: 1,
                    delay: .3,
                    ease: "power2.out"
                }, 'start')

                // subtitles
                const splittextsubtitles = new SplitText(servicesolo.querySelector('.sub-title-service'), {
                    type: "lines",
                    linesClass: "split-line-child"
                });
                new SplitText(servicesolo.querySelector('.sub-title-service'), {
                    type: "lines",
                    linesClass: "split-line-parent"
                });
                tl.from(splittextsubtitles.lines, {
                    duration: 1.5,
                    y: 100,
                    ease: "power4",
                    stagger: 0.1,
                    delay: .25
                }, 'start');

                // titles
                const splittext = new SplitText(servicesolo.querySelector('.title-service'), {
                    type: "lines",
                    linesClass: "split-line-child"
                });
                new SplitText(servicesolo.querySelector('.title-service'), {type: "lines", linesClass: "split-line-parent"});
                tl.from(splittext.lines, {
                    duration: 1.5,
                    y: 100,
                    ease: "power4",
                    stagger: 0.1,
                    delay: .25
                }, 'start+=.15');
                tl.addLabel('endtexts', '<')
            }
            if (btn) {
                const btnrect = btn.getBoundingClientRect()
                const wrapper = btn.parentNode
                wrapper.style.height = btnrect.height+'px'
                wrapper.style.overflow = 'hidden'
                tl.from(btn, {
                    y: -100,
                    opacity: 0,
                    stagger: 0.1,
                    duration: 1.25,
                    // delay: .3*i,
                    ease: "power4"
                }, '>-1')
            }
            if (window.innerWidth < 768) {
                const childs = document.querySelectorAll('#root-services-childs > .item-root-service-child')
                childs.forEach(function (item, i) {
                    tl.fromTo(item,
                        {
                            y: 15,
                            opacity: 0
                        },
                        {
                            y: 0,
                            opacity: 1,
                            delay: .2*i,
                            duration: .35,
                            ease: "power3.inOut",
                        },
                        'endtexts+=.25'
                    )
                });
            }
            tl.addLabel("start", 0);
            tl.play()
            servicesolo.classList.add('animation-completed')
        }
    },
    level2: () => {
        const mainview = document.querySelector('#main-view')
        const mainviewrect = mainview.getBoundingClientRect()
        mainview.style.position = 'fixed'
        mainview.style.top = mainviewrect.y+'px'

        // console.warn('ENTER LEVEL 2 - RENDER');

        /** size toolbar */
        // self.components.front.toolbarActions.sizeToolbar();

        /** Set panel class service details */
        let serviceDetails = document.querySelector('#root-service-details');
        if (serviceDetails) {
            serviceDetails.classList.add('panel-loaded');
        }
    }
}

const routerView = document.querySelector('[data-router-view]')
if (routerView) {
    renderers[routerView.dataset.routerView]()
}
